export default __webpack_public_path__ + "static/media/logo-kiara.d33688ef.svg";